// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3AAyE","index":"styles_index__1oZz9"};